export default __webpack_public_path__ + "static/media/background-4.cfade5f0.png";